<template>
  <div class="main-container" :style="{background: getImageURL(selectContent.content), 'background-size': 'cover'}">
    <div class="cover-filter">
      <div class="title-content">
        <h1 class="main-title">
          <input class="edit-input font-main" placeholder="タイトルを入力" v-model="selectContent.content.title.text">
        </h1>
        <h2 class="sub-title">
          <input class="edit-input font-sub" placeholder="キャッチコピー等を入力" v-model="selectContent.content.sub_title.text">
        </h2>
      </div>
      <a class="background-img-button" @click="searchPhotos('job');isModal=true" v-if="!isMobile">
        <span class="mdi mdi-plus" style="margin-right: 10px;"></span>背景を変更
      </a>
    </div>
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            画像を選択
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            画像：<a href="https://unsplash.com/">Unsplash</a>
            <input class="input" @keydown.meta.enter="searchPhotos(search)" v-model="search"/>
            <hr>
            <ul class="horizontal-image">
              <li v-for="photo in photos" :key="photo.id">
                <img @click="saveImageAPI(photo.urls)" class="image-list" height="300" width="300" :src="photo.urls.thumb" alt="img"/>
              </li>
            </ul>
            <hr>
            <b-field position="is-centered" style="text-align: center !important;">
              <div class="upload-form">
                <a class="upload-style">
                  <label for="file_upload" class="upload-style">
                    <a class="button is-primary">
                      <span class="mdi mdi-image" style="margin-right: 10px;"></span>自分のPCから画像のアップロードする
                    </a>
                    <input type="file" id="file_upload" @change="onFileChange">
                  </label>
                </a>
              </div>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MainTitle',
  componentName: 'MainTitle',
  props: [
    'isMobile',
    'isView'
  ],
  components: {
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['selectContent'])
  },
  data () {
    return {
      isModal: false,
      search: '',
      photos: []
    }
  },
  methods: {
    onFileChange (e) {
      console.debug('*** Start *** onFileChange')
      console.debud('e: ' + JSON.stringify(e))
      let files = e.target.files || e.dataTransfer.files
      this.filename = files[0].name
      let reader = new FileReader()
      reader.onload = (e) => {
        this.$store.dispatch('employmentPage/postContentImage', {contents_id: this.selectContent.contents_id, image_id: this.selectContent.content.image.id, data: e.target.result, index: 0, is_original: true})
      }
      reader.readAsDataURL(files[0])
      this.isModal = false
      console.debug('*** End *** onFileChange')
    },
    getImageURL (content) {
      console.debug('*** Start *** getImageURL')
      console.debug('content: ' + JSON.stringify(content))
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (content.image.url == '') return 'url(\"' + defaultURL + '\") center center no-repeat'
      else return 'url(\"' + content.image.url + '\") center center no-repeat'
    },
    saveImageAPI (url) {
      console.debug('*** Start *** saveImageAPI')
      console.debug('url: ' + JSON.stringify(url))
      var setUrl = ''
      if (url['full']) setUrl = url.full
      else setUrl = url.raw
      console.log('***IMAGE:' + JSON.stringify(url))
      this.$store.dispatch('employmentPage/postContentImage', {contents_id: this.selectContent.contents_id, image_id: this.selectContent.content.image.id, data: setUrl, index: 0, is_original: false})
      this.isModal = false
      console.debug('*** End *** saveImageAPI')
    },
    searchPhotos (search) {
      console.debug('*** Start *** searchPhotos')
      console.debug('search: ' + JSON.stringify(search))
      let appid = this.$unsplash._applicationId
      let query  = search
      this.$axios.get(`https://api.unsplash.com/search/photos/?page=1&per_page=20&query=${query}&client_id=${appid}&width=1920&height=1080`)
      .then(response => {
        this.photos = response.data.results
      })
      .catch(e => {
        console.log(e)
      })
      console.debug('*** End *** searchPhotos')
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 24px);
  width: 100%;
  background: rgba(0, 0, 0, 0.3) no-repeat center;
  background-size: cover !important;
}
.cover-filter{
  display: flex;
  justify-content: center;
  align-items: center;
  height:100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.3) no-repeat center;
}
.title-content {
  width: 95%;
}
.main-title {
  color: white;
  font-size: 25px;
  border: dashed thin #eee;
}
.sub-title {
  color: white;
  font-size: 20px;
  border: dashed thin #eee;
}
.edit-input {
  background: rgba(255,255,255, 0.00) !important;
  width: 100%;
  text-align: center;
  color: white;
  border: none;
}
.font-main {
  font-size: 25px;
}
.font-sub {
  font-size: 20px;
}
.upload-form {
  position: relative;
}
.upload-style {
  width: 200px;
  border-radius: 10px;
}
.upload-style > input {
  display: none;
}
.background-img {
  background: rgba(255,255,255, 0.00) !important;
  border: solid thin #ccc;
  font-size: 20px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  color: black;
}
.background-img-button {
  background: rgba(255,255,255, 0.00) !important;
  border: dashed thin #eee;
  font-size: 20px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.horizontal-image {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  height: 300px;
  width: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.horizontal-image li {
  background: #fff;
  margin: 2px;
  text-align: center;
  width: 230px;
}
.image-list {
  width: 230px;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/MainTitle.vue